import React from 'react';
import PageHeader from '../components/PageHeader';
import CTASection from '../components/CTASection';

const values = [
  {
    title: 'Neighbors First',
    body: 'Decisions are measured by how they affect the people who live here, not outside interests or political pressure. Every resident deserves a legislator who knows their name and listens to the people of Big Flats before acting.',
  },
  {
    title: 'Honest Government',
    body: 'Open books, open meetings, open doors. Taxpayers deserve to see exactly how their money is spent and to hear the truth even when it’s hard.',
  },
  {
    title: 'Main Street Strong',
    body: 'Local businesses are the heart of our town. Supporting small employers, family farms, and homegrown entrepreneurs keeps our economy and our identity intact.',
  },
  {
    title: 'Roots and Roads',
    body: 'Honor the traditions, history, and character that make our town special, while maintaining the practical infrastructure — roads, water, public safety — that families rely on every day.',
  },
  {
    title: 'Common-Sense Stewardship',
    body: 'Spend public dollars the way a family budgets at the kitchen table. Live within our means, plan for the future, and never burden the next generation with today’s bills.',
  },
  {
    title: 'Service Over Politics',
    body: 'A seat on the county legislature is a job, not a stepping stone. Show up, work hard, return the call, and put Big Flats and Chemung County ahead of any party or personal ambition.',
  },
];

function ValuesPage() {
  return (
    <>
      <PageHeader
        eyebrow="Core Values"
        title="What I Stand For"
        lead="These aren’t slogans. They’re the same principles Ron has used to run businesses, raise a family, and serve his community."
      />

      <section className="section values values--page">
        <div className="container">
          <div className="values__grid">
            {values.map((v, i) => (
              <div className="value-card" key={v.title}>
                <div className="value-card__num">0{i + 1}</div>
                <h3>{v.title}</h3>
                <p>{v.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <h2 className="section__title">In Ron&rsquo;s Own Words</h2>
          <blockquote className="long-quote">
            &ldquo;I&rsquo;m not trying to be slippery and not take a line. I
            just want to do my homework and my due diligence. On any topic, I
            need to look at the facts before I make a statement. But honesty
            and transparency are not negotiable for me &mdash; they&rsquo;re
            how I&rsquo;ve run every business I&rsquo;ve managed.&rdquo;
            <cite>&mdash; Ron Johanson</cite>
          </blockquote>
        </div>
      </section>

      <CTASection />
    </>
  );
}

export default ValuesPage;
